__turbopack_context__.v({
  "actions": "ReferenceExplorers-module__NX2A1q__actions",
  "bigPreview": "ReferenceExplorers-module__NX2A1q__bigPreview",
  "blipCard": "ReferenceExplorers-module__NX2A1q__blipCard",
  "blipGrid": "ReferenceExplorers-module__NX2A1q__blipGrid",
  "blipList": "ReferenceExplorers-module__NX2A1q__blipList",
  "builder": "ReferenceExplorers-module__NX2A1q__builder",
  "builderControls": "ReferenceExplorers-module__NX2A1q__builderControls",
  "checkbox": "ReferenceExplorers-module__NX2A1q__checkbox",
  "checks": "ReferenceExplorers-module__NX2A1q__checks",
  "chip": "ReferenceExplorers-module__NX2A1q__chip",
  "code": "ReferenceExplorers-module__NX2A1q__code",
  "colourDetails": "ReferenceExplorers-module__NX2A1q__colourDetails",
  "colourGrid": "ReferenceExplorers-module__NX2A1q__colourGrid",
  "colourRow": "ReferenceExplorers-module__NX2A1q__colourRow",
  "detailHeading": "ReferenceExplorers-module__NX2A1q__detailHeading",
  "empty": "ReferenceExplorers-module__NX2A1q__empty",
  "explorer": "ReferenceExplorers-module__NX2A1q__explorer",
  "eyebrow": "ReferenceExplorers-module__NX2A1q__eyebrow",
  "favorite": "ReferenceExplorers-module__NX2A1q__favorite",
  "fieldGrid": "ReferenceExplorers-module__NX2A1q__fieldGrid",
  "filterRow": "ReferenceExplorers-module__NX2A1q__filterRow",
  "filters": "ReferenceExplorers-module__NX2A1q__filters",
  "heading": "ReferenceExplorers-module__NX2A1q__heading",
  "language": "ReferenceExplorers-module__NX2A1q__language",
  "muted": "ReferenceExplorers-module__NX2A1q__muted",
  "nativeDetail": "ReferenceExplorers-module__NX2A1q__nativeDetail",
  "nativeItem": "ReferenceExplorers-module__NX2A1q__nativeItem",
  "nativeLayout": "ReferenceExplorers-module__NX2A1q__nativeLayout",
  "nativeList": "ReferenceExplorers-module__NX2A1q__nativeList",
  "pager": "ReferenceExplorers-module__NX2A1q__pager",
  "paramTable": "ReferenceExplorers-module__NX2A1q__paramTable",
  "search": "ReferenceExplorers-module__NX2A1q__search",
  "selectedBlip": "ReferenceExplorers-module__NX2A1q__selectedBlip",
  "selectedColour": "ReferenceExplorers-module__NX2A1q__selectedColour",
  "sourceNote": "ReferenceExplorers-module__NX2A1q__sourceNote",
  "spriteChoice": "ReferenceExplorers-module__NX2A1q__spriteChoice",
  "spriteName": "ReferenceExplorers-module__NX2A1q__spriteName",
  "spriteText": "ReferenceExplorers-module__NX2A1q__spriteText",
  "spriteThumb": "ReferenceExplorers-module__NX2A1q__spriteThumb",
  "swatch": "ReferenceExplorers-module__NX2A1q__swatch",
  "wideField": "ReferenceExplorers-module__NX2A1q__wideField",
});
